<template>
  <div>
    <Selector ref="Selector"></Selector>
    <Modal title="按下面格式要求导入excel文件" v-model="loadDataModal" width="500">
      <p>文件第一行标题如下：</p><br>
      <p>公网IP、端口、服务器用户名、服务器密码</p><br>
      <p style="color: red">只支持.xls或.xlsx格式文件</p>
      <p style="color: red">端口从系统里面最大端口+1开始即可</p>
      <div slot="footer">
        <Upload :action="uploadHunterBrowserDataUrl"
                :headers="uploadHeader"
                accept=".xls, .xlsx"
                :max-size="10240"
                :before-upload="handleBeforeUpload"
                :on-exceeded-size="maxSize"
                :on-success="handleFileSuccess"
                :on-error="handleFileError">
          <Button icon="ios-cloud-upload-outline" type="primary">选择文件</Button>
         </Upload>
         <a :href="downUrl" target="_blank" download>下载模板</a>
      </div>
    </Modal>
    <Modal
      :title="hunterBrowserModalTitle"
      v-model="hunterBrowserModal"
      width="500"
      footer-hide
      @on-close="hunterBrowserModalCancel">
      <div>
        <Form ref="hunterBrowserForm" :model="hunterBrowserForm" :label-width="65" :rules="hunterBrowserRule">
          <FormItem label="公网IP" prop="public_ip">
            <Input v-model="hunterBrowserForm.public_ip" />
          </FormItem>
          <FormItem label="备注" prop="private_ip">
            <Input v-model="hunterBrowserForm.private_ip" />
          </FormItem>
          <FormItem label="端口" prop="port">
            <InputNumber v-model="hunterBrowserForm.port" />
          </FormItem>
          <FormItem label="用户名" prop="user">
            <Input v-model="hunterBrowserForm.user" />
          </FormItem>
          <FormItem label="密码" prop="password">
            <Input v-model="hunterBrowserForm.password" />
          </FormItem>
          <FormItem label="服务器用户名" prop="server_user">
            <Input v-model="hunterBrowserForm.server_user" />
          </FormItem>
          <FormItem label="服务器密码" prop="server_password">
            <Input v-model="hunterBrowserForm.server_password" />
          </FormItem>
          <FormItem label="服务器密码" prop="os">
            <RadioGroup v-model="hunterBrowserForm.os">
              <Radio label="linux">Linux</Radio>
              <Radio label="windows">Windows</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="已部署" prop="deployed">
            <i-switch v-model="hunterBrowserForm.deployed">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="hunterBrowserSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="hunterBrowserModal = false">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <Card>
      <Row>
        <Col :md="18">
          <Form inline :label-width="50" ref="searchHunterBrowserForm" :model="searchHunterBrowserForm">
            <FormItem label="端口">
              <InputNumber :min="1" v-model="searchHunterBrowserForm.port" @on-enter="getData()" placeholder="过滤端口" style="width: 200px"/>
            </FormItem>
            <FormItem label="公网IP">
              <Input v-model="searchHunterBrowserForm.public_ip" @on-enter="getData()" placeholder="过滤公网IP" style="width: 200px"/>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getData()" style="margin-right: 8px">搜索</Button>
              <Button @click="resetHunterBrowserSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col :md="6" class="align-right">
          <Button
          @click="loadDataModal = true"
          style="margin-right: 10px"
          type="primary"
          :style="{marginBottom: '10px'}"
          icon="ios-cloud-upload-outline">导入</Button>
          <Button
            @click="getData(hunterBrowser.page)"
            style="margin-right: 10px"
            :style="{marginBottom: '10px'}">刷新</Button>
          <Button
          @click="openSelectModal"
          style="margin-right: 10px"
          type="primary"
          :style="{marginBottom: '10px'}">批量部署</Button>
          <Button
            @click="hunterBrowserModalOpen"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">添加</Button>
        </Col>
      </Row>
      <Table
        size="small"
        border
        @on-sort-change="sortChange"
        :loading="tableLoading"
        :data="hunterBrowser.data"
        :columns="hunterBrowser.columns" min-width="260">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="hunterBrowser.count"
            :current="hunterBrowser.page"
            :page-size="hunterBrowser.size"
            @on-change="getData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getHunterBrowser, changeHunterBrowser, deleteHunterBrowser, hunterBrowserTestConn, hunterBrowserRestartService,
  hunterBrowserCheckBindStatus, hunterBrowserDeploy, uploadHunterBrowserDataUrl } from '@/api/opscenter'
import Selector from './selector'

export default {
  name: 'list',
  components: {
    Selector
  },
  data () {
    return {
      downUrl: 'https://aukeyfile.obs.cn-south-1.myhuaweicloud.com/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
      tableLoading: false,
      hunterBrowserModal: false,
      hunterBrowserTableLoading: false,
      hunterBrowserModalTitle: '添加',
      searchHunterBrowserForm: {
        port: '',
        public_ip: '',
        ordering: ''
      },
      hunterBrowserForm: {
        id: 0,
        public_ip: '',
        private_ip: '',
        port: null,
        user: '',
        password: '',
        deployed: false,
        server_user: '',
        server_password: '',
        os: 'linux'
      },
      hunterBrowserRule: {
        public_ip: { required: true, message: '公网IP不能为空', trigger: 'blur' },
        port: { required: true, message: '端口不能为空', trigger: 'blur', type: 'number' },
        user: { required: true, message: '用户名不能为空', trigger: 'blur' },
        password: { required: true, message: '密码不能为空', trigger: 'blur' },
        server_user: { required: true, message: '服务器用户名不能为空', trigger: 'blur' },
        server_password: { required: true, message: '服务器密码不能为空', trigger: 'blur' }
      },
      hunterBrowser: {
        data: [],
        columns: [
          {
            title: 'ID',
            key: 'id',
            align: 'center',
            minWidth: 60,
            sortable: 'custom'
          },
          {
            title: '端口',
            key: 'port',
            align: 'center',
            minWidth: 90,
            sortable: 'custom'
          },
          {
            title: '公网IP',
            key: 'public_ip',
            align: 'center',
            minWidth: 125
          },
          {
            title: '用户名',
            key: 'user',
            align: 'center',
            minWidth: 100
          },
          {
            title: '密码',
            key: 'password',
            align: 'center',
            minWidth: 100
          },
          {
            title: '服务器用户名',
            key: 'server_user',
            align: 'center',
            minWidth: 110,
            sortable: 'custom'
          },
          {
            title: '服务器密码',
            key: 'server_password',
            align: 'center',
            minWidth: 100,
            sortable: 'custom'
          },
          {
            title: '操作系统',
            key: 'os',
            align: 'center',
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              return h('span', [
                h('Icon', {
                  props: {
                    type: `iconfont icon-${params.row.os}`
                  },
                  style: {
                    'font-family': 'iconfont',
                    'margin-right': '5px'
                  }
                }),
                h('span', params.row.os)
              ])
            }
          },
          {
            title: '备注',
            key: 'private_ip',
            align: 'center',
            minWidth: 90,
            sortable: 'custom'
          },
          {
            title: '是否已部署',
            key: 'deployed',
            align: 'center',
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              return h('span', params.row.deployed ? '是' : '否')
            }
          },
          {
            title: '绑定状态',
            key: 'bind_status',
            align: 'center',
            minWidth: 100,
            sortable: 'custom',
            render: (h, params) => {
              return h('Badge', {
                props: {
                  text: params.row.bind_status === null ? '未检测' : params.row.bind_status ? '正常' : '异常',
                  status: params.row.bind_status === null ? 'warning' : params.row.bind_status ? 'success' : 'error'
                }
              })
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 350,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.connTest(params.row)
                    }
                  }
                }, '检测连通性'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.CheckBindStatus(params.row)
                    }
                  }
                }, '绑定检测'),
                h('Button', {
                  style: {
                    display: !params.row.deployed ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.deploy(params.row)
                    }
                  }
                }, '开始部署'),
                h('Button', {
                  style: {
                    display: params.row.deployed && !params.row.bind_status ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.hunterBrowserRestartService(params.row)
                    }
                  }
                }, '重启服务'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.hunterBrowserModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    transfer: true,
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.hunterBrowserDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 15
      },
      testConning: false,
      bindStatusChecking: false,
      deploying: false,
      uploadHunterBrowserDataUrl: uploadHunterBrowserDataUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      loadDataModal: false,
      uploadLoading: false,
      serviceRestarting: false
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    hunterBrowserModalOpen () {
      this.hunterBrowserModalTitle = '添加'
      this.hunterBrowserFormReset()
      this.hunterBrowserModal = true
    },
    hunterBrowserModalCancel () {
      this.hunterBrowserFormReset()
      this.hunterBrowserModal = false
    },
    hunterBrowserFormReset () {
      this.hunterBrowserForm.id = 0
      this.hunterBrowserForm.public_ip = ''
      this.hunterBrowserForm.private_ip = ''
      this.hunterBrowserForm.port = null
      this.hunterBrowserForm.user = ''
      this.hunterBrowserForm.password = ''
      this.hunterBrowserForm.server_user = 'ubuntu'
      this.hunterBrowserForm.server_password = 'wsx-edc123'
      this.hunterBrowserForm.os = 'linux'
      this.hunterBrowserForm.deployed = false
    },
    hunterBrowserSubmit () {
      this.$refs['hunterBrowserForm'].validate((valid) => {
        if (valid) {
          changeHunterBrowser(this.hunterBrowserForm, this.hunterBrowserForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getData(this.hunterBrowser.page)
            this.hunterBrowserFormReset()
            this.hunterBrowserModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getData (value = 1) {
      this.hunterBrowser.page = value
      let params = {
        size: this.hunterBrowser.size,
        page: this.hunterBrowser.page,
        public_ip: this.searchHunterBrowserForm.public_ip,
        port: this.searchHunterBrowserForm.port,
        ordering: this.searchHunterBrowserForm.ordering
      }
      this.tableLoading = true
      getHunterBrowser(params).then(res => {
        this.tableLoading = false
        this.hunterBrowser.data = res.data.results
        this.hunterBrowser.count = res.data.count
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取列表失败！服务器无响应'
          })
        }
      })
    },
    hunterBrowserModifyOpen (row) {
      this.hunterBrowserForm.id = row.id
      this.hunterBrowserForm.public_ip = row.public_ip
      this.hunterBrowserForm.private_ip = row.private_ip
      this.hunterBrowserForm.port = row.port
      this.hunterBrowserForm.user = row.user
      this.hunterBrowserForm.password = row.password
      this.hunterBrowserForm.server_user = row.server_user
      this.hunterBrowserForm.server_password = row.server_password
      this.hunterBrowserForm.deployed = row.deployed
      this.hunterBrowserForm.os = row.os
      this.hunterBrowserModalTitle = '编辑'
      this.hunterBrowserModal = true
    },
    hunterBrowserDelete (row) {
      deleteHunterBrowser(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    connTest (row) {
      if (this.testConning) {
        return
      }
      this.testConning = true
      const msg = this.$Message.loading({
        content: '测试连接中...',
        duration: 0
      })
      hunterBrowserTestConn(row.id).then(res => {
        this.testConning = false
        setTimeout(msg, 0)
        if (res.data.result) {
          this.$Message['success']({
            background: true,
            content: '连接成功'
          })
        } else {
          this.$Message['error']({
            background: true,
            content: '连接失败'
          })
        }
      }).catch(res => {
        this.testConning = false
        setTimeout(msg, 0)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    CheckBindStatus (row) {
      if (this.bindStatusChecking) {
        return
      }
      this.bindStatusChecking = true
      const msg = this.$Message.loading({
        content: '检测绑定状态中...',
        duration: 0
      })
      hunterBrowserCheckBindStatus(row.id).then(res => {
        this.bindStatusChecking = false
        setTimeout(msg, 0)
        if (res.data.conn_status) {
          if (res.data.result) {
            this.$Message['success']({
              background: true,
              content: '绑定状态正常'
            })
            this.getData(this.hunterBrowser.page)
          } else {
            this.$Message['error']({
              background: true,
              content: '绑定状态异常'
            })
          }
        } else {
          this.$Notice.error({
            title: row.public_ip + ' 服务器连接失败！'
          })
        }
      }).catch(res => {
        this.bindStatusChecking = false
        setTimeout(msg, 0)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    deploy (row) {
      if (this.deploying) {
        return
      }
      this.deploying = true
      const msg = this.$Message.loading({
        content: '部署中...',
        duration: 0
      })
      hunterBrowserDeploy(row.id).then(res => {
        this.deploying = false
        setTimeout(msg, 0)
        if (res.data.target_conn_failed) {
          this.$Message['error']({
            background: true,
            content: '目标机器连接失败'
          })
          return
        }
        if (res.data.conn_status) {
          if (res.data.result) {
            this.$Message['success']({
              background: true,
              content: '部署成功'
            })
            this.getData(this.hunterBrowser.page)
          } else {
            this.$Message['error']({
              background: true,
              content: '部署失败'
            })
          }
        } else {
          this.$Notice.error({
            title: row.public_ip + ' 检测服务器连接失败！无法校验是否部署成功'
          })
        }
      }).catch(res => {
        this.deploying = false
        setTimeout(msg, 0)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.uploadLoading = true
        return true
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    maxSize () {
      this.$Notice.warning({ title: '文件太大, 限制最大10M' })
    },
    handleFileSuccess (res, file) {
      this.uploadLoading = false
      this.loadDataModal = false
      this.$Notice.success({
        title: '导入成功' + res.count.toString() + '条 ！'
      })
    },
    handleFileError (res, file) {
      console.log('导入失败')
      this.uploadLoading = false
      this.loadDataModal = false
      this.$Notice.error({
        title: '导入失败',
        desc: '检查端口是否重复 ！'
      })
    },
    // 打开选择Modal
    openSelectModal () {
      this.$refs.Selector.openSelectHunterBrowserModal()
    },
    // 重置搜索表单
    resetHunterBrowserSearchForm () {
      this.searchHunterBrowserForm = {
        port: '',
        public_ip: '',
        inner_ip: ''
      }
      this.getData()
    },
    // 排序
    sortChange (params) {
      if (params.order === 'asc') {
        this.searchHunterBrowserForm.ordering = params.key
      } else if (params.order === 'desc') {
        this.searchHunterBrowserForm.ordering = '-' + params.key
      } else {
        this.searchHunterBrowserForm.ordering = ''
      }
      this.getData(this.hunterBrowser.page)
    },
    hunterBrowserRestartService (row) {
      if (this.serviceRestarting) {
        return
      }
      this.serviceRestarting = true
      const msg = this.$Message.loading({
        content: '服务重启中...',
        duration: 0
      })
      hunterBrowserRestartService(row.id).then(res => {
        this.serviceRestarting = false
        setTimeout(msg, 0)
        this.$Message['success']({
          background: true,
          content: '服务重启成功'
        })
        this.getData(this.hunterBrowser.page)
      }).catch(res => {
        this.serviceRestarting = false
        setTimeout(msg, 0)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
